import { render, staticRenderFns } from "./AuthPhoneUser.vue?vue&type=template&id=e8838858&scoped=true"
import script from "./AuthPhoneUser.vue?vue&type=script&lang=js"
export * from "./AuthPhoneUser.vue?vue&type=script&lang=js"
import style0 from "./AuthPhoneUser.vue?vue&type=style&index=0&id=e8838858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8838858",
  null
  
)

export default component.exports